import {useCallback} from "@wordpress/element";
import {dispatch} from '@wordpress/data';

export const useNotices = ({context, ...props}) => {
    const {createErrorNotice} = dispatch('core/notices');

    const onError = useCallback((error) => {
        if (props.onError) {
            props.onError(error);
        } else {
            createErrorNotice(error?.message ? error.message : error, {
                context
            });
        }
    }, [props?.onError, context]);

    return {
        onError
    }
}